import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function CookiePolicyPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-1670" data-mp="1akhrrc7j7xjr">
      <section className="bg-teal-900 text-white py-16" data-id="element-1671" data-mp="1akraceq8z2ff">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1672" data-mp="1fc0xn8obpto5">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1673" data-mp="1fe3xekfa3162">Cookie Policy</h1>
          <p className="text-teal-100" data-id="element-1674" data-mp="1kb43gvc4o3x6">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-1675" data-mp="1p8m47yfzrcu3">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1676" data-mp="1u90d1ipf2qt6">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-1677" data-mp="1u7p7pegbpazy">
            <p className="lead" data-id="element-1678" data-mp="1yalkgoj6mcvz">
              This Cookie Policy explains how Dentico Dental Clinic Ltd uses
              cookies and similar technologies on denticoclinic.co.uk.
            </p>

            <h3 data-id="element-1679" data-mp="3xm8d5e0g0tg">We use:</h3>
            <ul className="space-y-2" data-id="element-1680" data-mp="3yxc557gh8kk">
              <li data-id="element-1681" data-mp="3bdnrm96fzupr">
                <strong data-id="element-1682" data-mp="3be79jpw3ej3s">Strictly necessary cookies</strong> — required for core
                site functionality.
              </li>
              <li data-id="element-1683" data-mp="36kmcq168jv66">
                <strong data-id="element-1684" data-mp="31nm5vo1kaoe0">Analytics cookies</strong> — to understand website
                performance and improve user experience (used with consent where
                required).
              </li>
              <li data-id="element-1685" data-mp="3uc02bzd05cng">
                <strong data-id="element-1686" data-mp="3ucjltkiaw93l">Functional cookies</strong> — to remember preferences
                such as language/settings.
              </li>
              <li data-id="element-1687" data-mp="3pdyk1gnehhd1">
                <strong data-id="element-1688" data-mp="3pbccvi4f93vc">Marketing cookies</strong> (if enabled) — to measure
                campaign performance.
              </li>
            </ul>

            <h3 data-id="element-1689" data-mp="3fdzb3in2jozn">Managing Cookies</h3>
            <p data-id="element-1690" data-mp="3fer3ylpa78m8">
              You can manage cookie preferences in our cookie banner/settings
              and in your browser.
            </p>
            <p data-id="element-1691" data-mp="23zcahrwa6yvv">
              Some third-party services (e.g. analytics/maps/booking tools) may
              set cookies under their own policies.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1692" data-mp="vykc1uywtr60">
              <p data-id="element-1693" data-mp="100p0mfai3xls">
                Contact:{' '}
                <a href="mailto:info@denticoclinic.co.uk" className="text-teal-600 font-medium hover:underline" data-id="element-1694" data-mp="m27h6trmp79o">
                  info@denticoclinic.co.uk
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}